
import type { InjectionKey } from 'vue'
import type { FormContext, FormItemContext } from './types'

export const FormContextKey: InjectionKey<FormContext> = Symbol('FormContextKey')
export const FormItemContextKey: InjectionKey<FormItemContext> = Symbol('FormItemContextKey')
